module.exports = __webpack_public_path__ + "img/cvv-icon.094c6819.svg";